// source: pbtypes/gen/sensors/gps_quality_override.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_sensors_gps_quality_pb = require('../../../pbtypes/gen/sensors/gps_quality_pb.js');
goog.object.extend(proto, pbtypes_gen_sensors_gps_quality_pb);
goog.exportSymbol('proto.sensors.GpsQualityOverridePb', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.sensors.GpsQualityOverridePb = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.sensors.GpsQualityOverridePb, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.sensors.GpsQualityOverridePb.displayName = 'proto.sensors.GpsQualityOverridePb';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.sensors.GpsQualityOverridePb.prototype.toObject = function(opt_includeInstance) {
  return proto.sensors.GpsQualityOverridePb.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.sensors.GpsQualityOverridePb} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sensors.GpsQualityOverridePb.toObject = function(includeInstance, msg) {
  var f, obj = {
utime: jspb.Message.getFieldWithDefault(msg, 1, 0),
overrideEnabled: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
gpsQualityOverride: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.sensors.GpsQualityOverridePb}
 */
proto.sensors.GpsQualityOverridePb.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.sensors.GpsQualityOverridePb;
  return proto.sensors.GpsQualityOverridePb.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.sensors.GpsQualityOverridePb} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.sensors.GpsQualityOverridePb}
 */
proto.sensors.GpsQualityOverridePb.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readSint64());
      msg.setUtime(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOverrideEnabled(value);
      break;
    case 3:
      var value = /** @type {!proto.sensors.GpsQualityPb.Enum} */ (reader.readEnum());
      msg.setGpsQualityOverride(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.sensors.GpsQualityOverridePb.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.sensors.GpsQualityOverridePb.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.sensors.GpsQualityOverridePb} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sensors.GpsQualityOverridePb.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUtime();
  if (f !== 0) {
    writer.writeSint64(
      1,
      f
    );
  }
  f = message.getOverrideEnabled();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getGpsQualityOverride();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * optional sint64 utime = 1;
 * @return {number}
 */
proto.sensors.GpsQualityOverridePb.prototype.getUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.sensors.GpsQualityOverridePb} returns this
 */
proto.sensors.GpsQualityOverridePb.prototype.setUtime = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool override_enabled = 2;
 * @return {boolean}
 */
proto.sensors.GpsQualityOverridePb.prototype.getOverrideEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.sensors.GpsQualityOverridePb} returns this
 */
proto.sensors.GpsQualityOverridePb.prototype.setOverrideEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional GpsQualityPb.Enum gps_quality_override = 3;
 * @return {!proto.sensors.GpsQualityPb.Enum}
 */
proto.sensors.GpsQualityOverridePb.prototype.getGpsQualityOverride = function() {
  return /** @type {!proto.sensors.GpsQualityPb.Enum} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.sensors.GpsQualityPb.Enum} value
 * @return {!proto.sensors.GpsQualityOverridePb} returns this
 */
proto.sensors.GpsQualityOverridePb.prototype.setGpsQualityOverride = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


goog.object.extend(exports, proto.sensors);
